import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "../components/modules/LinksTable/ui.helpers";

const LinksUIContext = createContext();

export function useLinksUIContext() {
  return useContext(LinksUIContext);
}

export const LinksUIConsumer = LinksUIContext.Consumer;

export function LinksUIProvider({ linksUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);

  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }
      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      return nextQueryParams;
    });
  }, []);

  const { openLinkDetailDialog, goToCreateLink } = linksUIEvents;

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    openLinkDetailDialog,
    goToCreateLink,
  };

  return (
    <LinksUIContext.Provider value={value}>
      {children}
    </LinksUIContext.Provider>
  );
}
